import BaseApiService from './api.base.service'

class FunctionalitiesApiService extends BaseApiService {
  constructor() {
    super('functionalities')
  }

  GetUserTypesAndFunctionalities() {
    return this.callGet('')
  }

  getUsersFunctionalitiesByCustomersIdOdata(params) {
    return this.callGet(`/users/odata`, params)
  }

  updateUsersFunctionality(user) {
    var usersJson = JSON.stringify(user)
    return this.callPost(`/update`, usersJson, {
      headers: { 'Content-Type': 'application/json' },
    })
  }

  isParticipantAssociatedToClientByFunctionality(clientId, userFunctionality) {
    return this.callPost(`/is-associated`, { clientId, userFunctionality })
  }
}

export const functionalitiesApi = new FunctionalitiesApiService()
